var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpvote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0566 9.00391C15.5174 7.57689 15.75 6.32772 15.75 5.25065C15.75 2.85198 14.811 1.00323 13.25 1.00323C12.4033 1.00323 12.1412 1.50747 11.8133 2.75006C11.8304 2.68513 11.6504 3.38402 11.5977 3.57127C11.4968 3.93001 11.321 4.54076 11.0707 5.40228C11.064 5.42536 11.0542 5.44711 11.0413 5.46718L8.17457 9.95284C7.49652 11.0138 6.49605 11.8293 5.32017 12.2795L4.06293 12.7609C3.26956 13.0646 2.80894 13.8943 2.97066 14.7283L3.65682 18.267C3.82396 19.129 4.47726 19.815 5.33006 20.024L13.5796 22.0459C16.1108 22.6663 18.6692 21.1314 19.3131 18.606L20.8869 12.4334C21.2622 10.9617 20.3733 9.46441 18.9016 9.08917C18.6796 9.03256 18.4513 9.00391 18.2222 9.00391H15.0566Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpvote);
export default __webpack_public_path__ + "static/media/upvote.536e3393.svg";
export { ForwardRef as ReactComponent };